import React from 'react';
import {
  THREAD_STATUS_LABELS,
  RP_STATUS_LABELS,
  THREAD_TYPE_LABELS,
  getThreadModerationStatus,
  getThreadRpStatus,
  isRoleplayThread,
} from '../../utils/threadStatusLabels';
import styles from './ThreadStatusBadges.module.css';

const MODERATION_BADGE_CLASS = {
  open: 'badgeOpen',
  closed: 'badgeClosed',
  archived: 'badgeArchived',
};

const RP_BADGE_CLASS = {
  in_progress: 'badgeRpInProgress',
  completed: 'badgeRpCompleted',
  abandoned: 'badgeRpAbandoned',
};

const ThreadStatusBadges = ({
  thread,
  showType = true,
  showModerationStatus = true,
  showRpStatus = true,
  showPinned = true,
  className = '',
}) => {
  if (!thread) return null;

  const moderationStatus = getThreadModerationStatus(thread);
  const rpStatus = getThreadRpStatus(thread);
  const roleplay = isRoleplayThread(thread);
  const threadType = thread.type || (roleplay ? 'roleplay' : 'hrp');
  const typeLabel = THREAD_TYPE_LABELS[threadType] || threadType;

  return (
    <div className={`${styles.badges} ${className}`.trim()}>
      {showType && (
        <span className={`${styles.badge} ${roleplay ? styles.badgeType : styles.badgeTypeHrp}`}>
          {typeLabel}
        </span>
      )}

      {showModerationStatus && (
        <span className={`${styles.badge} ${styles[MODERATION_BADGE_CLASS[moderationStatus] || 'badgeOpen']}`}>
          {THREAD_STATUS_LABELS[moderationStatus] || moderationStatus}
        </span>
      )}

      {showRpStatus && roleplay && rpStatus && (
        <span className={`${styles.badge} ${styles[RP_BADGE_CLASS[rpStatus] || 'badgeRpInProgress']}`}>
          {RP_STATUS_LABELS[rpStatus] || rpStatus}
        </span>
      )}

      {showPinned && thread.pinned && (
        <span className={`${styles.badge} ${styles.badgePinned}`}>Épinglé</span>
      )}
    </div>
  );
};

export default ThreadStatusBadges;
